/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { WorkflowNode } from './workflow-node';
import { Function } from './function';
import { ServiceInstance } from './service-instance';

export class WorkflowServiceNode extends WorkflowNode {
    service: ServiceInstance;
    serviceFunction: Function;
    nextNode: WorkflowNode;
}
